module.exports = __webpack_public_path__ + "img/cat.5c41cd0c.svg";